import { render, staticRenderFns } from "./UserScriptsForm.vue?vue&type=template&id=061507f7&"
import script from "./UserScriptsForm.vue?vue&type=script&lang=js&"
export * from "./UserScriptsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports